<template>
  <v-container
    ><v-card>
      <v-card-title>{{ title }} </v-card-title>
      <v-card-text>
        <v-file-input
          v-model="uploadFile"
          ref="uploadFile"
          id="uploadFile"
          label="ไฟล์ข้อมูล (CSV)"
          show-size
          append-icon="mdi-file-import"
          accept=".csv"
        ></v-file-input>
        <v-btn color="success" dark class="mb-2" @click="save()" :disabled="!uploadable">
          <v-icon left>mdi-plus</v-icon>อัพโหลดไฟล์ </v-btn
        >[Download Template]</v-card-text
      >
      <v-card-text
        ><v-data-table :headers="headers" :items="items"></v-data-table
      ></v-card-text>
    </v-card>
    <!----->
    <v-dialog v-model="dialog" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          กำลังอัพโหลด
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!------>
    <div style="text-align: center; padding-left: 30% !important" width="100%">
      <v-alert
        v-if="responseStatus.alertStatus"
        :type="responseStatus.type"
        width="40%"
        style="z-index: 9999; text-align: left"
        dense
        dismissible
      >
        {{ responseStatus.text }}
      </v-alert>
    </div>
  </v-container>
</template>
<script>
import axios from "axios";
export default {
  name: "Import-Sale-Order",
  data() {
    return {
      api_uri: process.env.VUE_APP_LOYALTY_API_URI,
      dialog: false,
      //uploadable: false,
      uploadFile: null,
      title: "อิมพอร์ตข้อมูลการขาย",
      items: [],
      headers: [
        //{ text: "Date", value: "saleDate" },
        { text: "Filename", value: "filename" },
        { text: "Created At", value: "createdAt" },
      ],
      responseStatus: {
        alertStatus: false,
      },
    };
  },
  computed: {
    uploadable() {
      if (this.uploadFile !== null) {
        return true;
      }
      return false;
    },
  },
  mounted: {},
  methods: {
    async save() {
      this.dialog = !this.dialog;
      let formData = new FormData();
      console.log(this.uploadFile);
      formData.append("uploadFile", this.uploadFile);

      let result = await axios
        .post(
          this.api_uri + "/v1/import/" + sessionStorage.getItem("custId") + "/sale-order",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            timeout: 300 * 60 * 60,
            keepAliveTimeout: 1000 * 60 * 60,
          }
        )
        .then(function (data) {
          // console.log(data);
          //  console.log(data.data.statusCode);
          if (data.data.statusCode == 0) {
            //alert("Uploaded");
            //return data.data;
            this.responseStatus = {
              status: "Success",
              code: 0,
              color: "green",
              type: "success",
              text: "บันทึกสำเร็จ",
              alertStatus: true,
            };
          }
          //console.log(data.data);
        })
        .catch((e) => {
          //this.overlay = false;
          //alert("Upload failed");
          //this.overlay = false;
          //console.log("FAILURE!! " + e);
          this.responseStatus = {
            status: "Error",
            code: 0,
            color: "red",
            type: "error",
            text: e,
            alertStatus: true,
          };
        });
      this.dialog = false;
      if (result) {
        if (result.statusCode !== 0) {
          //alert("UPLOAD FAILED");
          this.responseStatus = {
            status: "Error",
            code: 0,
            color: "red",
            type: "error",
            text: result.statusText,
            alertStatus: true,
          };
        }
      }
    },
  },
};
</script>
